export enum ActionLink {
    StaticAction = 1,
    StaticActionWithId = 2,
    RouteAction= 3,
    RouteActionWithId = 4,
    RouteImage=5,
    RouteDynamic = 6
}
